<template>
  <v-container
    fluid
    pa-0
  >
    <!-- HEADER -->
    <pdf-admin-header
      :environment="environment"
      :title="title"
      :package-name="packageName"
      @submit="handleSubmit"
    />
    <!-- ACTION BAR -->
    <v-row
      class="action-bar"
      dense
      no-gutters
      align="center"
    >
      <v-col
        md="2"
        lg="2"
        xl="2"
        sm="auto"
        xs="auto"
      />
      <!-- ELEMENT ACTION BUTTONS -->
      <v-col
        cols="auto"
        style="width: 200px !important;"
      >
        <v-row
          class="align-center"
          dense
          v-if="file !== null"
        >
          <v-col class="text-center">
            <v-row
              v-if="file !== null"
              dense
            >
              <v-col cols="4">
                <!-- <v-btn
                  color="primary"
                  outlined
                  @click="reuploadFileWebhook"
                  v-if="checkWebhook"
                >
                  Re-upload
                </v-btn> -->
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <!-- PDF ACTION BUTTONS -->
      <v-spacer />
      <v-col
        cols="auto"
        class="text-center"
      >
        <pdf-navigation
          :page="page"
          :pages-count="pagesCount"
          @increment="page++"
          @decrement="page--"
        />
      </v-col>
      <v-spacer />
      <!-- ********************** PDF ZOOM BUTTONS ******************* -->
      <v-col
        cols="auto"
        style="width: 200px !important;"
      >
        <v-row
          class="align-center"
          dense
        >
          <v-col class="mt-1">
            <v-btn
              class="TierButton pb-0 text-center ml-1"
              icon
              @click="setPdfZoom(zoom - 0.2)"
            >
              <v-icon style="color: black;">
                mdi-magnify-minus-outline
              </v-icon>
            </v-btn>
            <v-btn
              class="TierButton pb-0 text-center ml-1"
              outlined
              width="110"
              height="30"
              @click="resetPdfZoom()"
            >
              RESET ZOOM
            </v-btn>
            <v-btn
              class="TierButton pb-0 text-center"
              icon
              @click="setPdfZoom(zoom + 0.2)"
            >
              <v-icon style="color: black;">
                mdi-magnify-plus-outline
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col
        md="2"
        lg="2"
        xl="2"
        sm="auto"
        xs="auto"
      />
    </v-row>
    <!-- Template Upload -->
    <v-row v-if="webhookId && file == null">
      <v-spacer />
      <v-col
        cols="12"
        md="7"
        lg="5"
      >
        <file-drop
          ref="pdfInput"
          accept="application/pdf"
          @files-selected="pdfUploaded"
        />
      </v-col>
      <v-spacer />
    </v-row>
    <!-- CONTENT -->

    <v-row
      no-gutters
      v-else
    >
      <v-col
        cols="4"
        style="overflow: hidden; height: (100vh-99px);"
        class="pt-0 pb-0 pr-3 pl-3"
      >
        <div ref="resizableDivDocuments">
          <span
            class="text-h6"
            v-if="documentList.length > 1"
          > Documents </span>
          <v-data-table
            :items="documentList"
            group-by="order"
            :hide-default-header="true"
            :hide-default-footer="true"
            v-if="documentList.length > 1"
            class="resizableDivDocuments"
          >
            <template v-slot:group="{ items }">
              <tr
                class="documentItem"
                :style="{
                  background:
                    items[0].id == currentDocument ? 'lightgreen' : 'white',
                  color: 'black',
                }"
              >
                <td
                  style="font-size: 15px;"
                  @click="changeCurrentDocument(items[0])"
                >
                  {{ items[0].originalName }}
                </td>
                <td
                  class="text-right"
                  style="width: 110px;"
                >
                  <v-btn
                    icon
                    dense
                    :disabled="items[0].order == 1"
                    @click="changeDocumentOrder(items[0], 1)"
                  >
                    <v-icon v-if="items[0].order != 1">
                      mdi-arrow-up
                    </v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    dense
                    :disabled="items[0].order == documentList.length"
                    @click="changeDocumentOrder(items[0], 0)"
                  >
                    <v-icon
                      v-if="items[0].order != documentList.length"
                    >
                      mdi-arrow-down
                    </v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
        <div ref="resizableDiv">
          <v-row
            dense
            class="mt-1"
          >
            <v-col class="text-h6">
              Signing Fields
            </v-col>
            <v-col
              class="text-right"
              cols="6"
            >
              <v-btn
                class="white--text"
                color="primary"
                outlined
                link
                @click="createNewUser()"
                v-if="!checkWebhook"
              >
                <v-icon>mdi-plus</v-icon>
                <v-tooltip
                  :open-delay="1500"
                  top
                >
                  <template #activator="{ on }">
                    <span v-on="on">New Signee</span>
                  </template>

                  <span>The individual who will be signing this document</span>
                </v-tooltip>
              </v-btn>
            </v-col>
          </v-row>

          <v-row
            style="overflow: hidden;"
            class="pt-0 my-0"
          >
            <v-col style="height: 100%;">
              <!-- Elements -->
              <div v-resize="onResize">
                <v-data-table
                  :items="activeDocument && activeDocument.template ? activeDocument.template.roles : []"
                  :headers="itemsHeaders"
                  group-by="order"
                  dense
                  fixed-header
                  :height="tableHeight"
                  :item-class="returnItemColor"
                  class="elementsTable"
                  :hide-default-footer="true"
                >
                  <template v-slot:group="{ items }">
                    <tr :style="{ backgroundColor: items[0].color }">
                      <td id="signeeName">
                        <a
                          style="text-decoration: none; color: black;"
                          @click="clickRoleOption = items[0].order"
                        >
                          Signee Role: <strong>{{ items[0].name }}</strong>
                        </a>
                      </td>
                      <td />
                      <td />
                      <td />
                      <td
                        id="cellOverflow"
                        :style="{ background: items[0].color }"
                      >
                        <v-menu>
                          <template v-slot:activator="{ attrs, on }">
                            <v-btn
                              style="font-size: 11.9px;"
                              outlined
                              v-bind="attrs"
                              v-on="on"
                              color="primary"
                              width="110"
                              height="20"
                              class="no-uppercase"
                            >
                              <v-tooltip
                                top
                                :open-delay="1500"
                              >
                                <template #activator="{ on }">
                                  <v-icon
                                    small
                                    color="primary"
                                  >
                                    mdi-plus
                                  </v-icon>
                                  <span v-on="on">Signing Field</span>
                                </template>
                                <span>A new field that the signee must fill out</span>
                              </v-tooltip>
                            </v-btn>
                          </template>
                          <v-list>
                            <v-list-item
                              v-for="element in elementTypes"
                              :key="element.id"
                              link
                              @click="newElement(element.id, element.name, items[0])"
                            >
                              <v-list-item-title
                                v-text="element.name"
                              />
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </td>
                      <td v-if="signeeOrderType == 2">
                        <v-row dense>
                          <v-col cols="5">
                            <v-btn
                              v-if="items[0].order != 1"
                              icon
                              dense
                              @click="changeOrder(items[0], 1)"
                            >
                              <v-icon>mdi-arrow-up</v-icon>
                            </v-btn>
                          </v-col>
                          <v-col cols="6">
                            <v-btn
                              v-if="items[0].order != activeDocument.template.roles.length"
                              icon
                              dense
                              @click="changeOrder(items[0], 0)"
                            >
                              <v-icon>mdi-arrow-down</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </td>
                    </tr>

                    <template v-for="item in items">
                      <tr
                        class="rowElement"
                        v-for="element in item.elements"
                        :key="element.temporaryId"
                        style=""
                      >
                        <td style="font-weight: bold;">
                          {{ element.label }}
                        </td>
                        <td>{{ element.elementType }}</td>
                        <td>
                          <v-autocomplete
                            hide-details=""
                            dense
                            v-model="element.fontId"
                            style="width: 40px;"
                            :items="fonts"
                            :value="1"
                            item-text="name"
                            item-value="id"
                            class="mt-0"
                            @input="changeFonts"
                          />
                        </td>
                        <td>
                          <v-text-field
                            hide-details=""
                            dense
                            type="number"
                            v-model="element.fontSize"
                            style="width: 35px;"
                            class="mt-0"
                            @input="changeFonts"
                          />
                        </td>
                        <td
                          id="cellOverflow"
                          :style="{ background: 'white' }"
                        >
                          <div class="action-cell">
                            <v-row dense>
                              <v-col cols="6">
                                <v-btn
                                  style="font-size: 11.9px; min-width: 0 !important;"
                                  outlined
                                  color="success"
                                  width="45"
                                  height="20"
                                  class="no-uppercase"
                                  @click="place(element.temporaryId, element.elementTypeId)"
                                >
                                  <v-tooltip
                                    :open-delay="1500"
                                    top
                                  >
                                    <template #activator="{ on }">
                                      <span v-on="on">Place</span>
                                    </template>

                                    <span>Add the signing field to the PDF document</span>
                                  </v-tooltip>
                                </v-btn>
                              </v-col>

                              <v-col
                                cols="6"
                              >
                                <v-btn
                                  style="font-size: 11.9px; min-width: 0 !important;"
                                  outlined
                                  color="error"
                                  width="50"
                                  height="20"
                                  class="no-uppercase pl-0 pr-0"
                                  @click="deleteElement(element.temporaryId)"
                                >
                                  Delete
                                </v-btn>
                              </v-col>
                            </v-row>
                          </div>
                        </td>
                        <td v-if="signeeOrderType == 2" />
                      </tr>
                    </template>
                  </template>
                </v-data-table>
              </div>
            </v-col>
          </v-row>
        </div>
        <v-divider />
        <div ref="resizableDivLifespan">
          <v-form
            ref="documentDataForm"
            reset="Function"
          >
            <v-row
              dense
              class="align-center"
            >
              <v-col cols="12" />
            </v-row>
            <v-row
              dense
              class="align-center"
            >
              <v-col
                cols="2"
                id="lifespan"
                class="pb-4"
              >
                <v-tooltip
                  :open-delay="1500"
                  top
                >
                  <template #activator="{ on }">
                    <span v-on="on">Lifespan:</span>
                  </template>

                  <span>Duration for document signing</span>
                </v-tooltip>
              </v-col>
              <v-col cols="10">
                <v-row dense>
                  <v-col
                    class="pt-0"
                  >
                    <v-text-field
                      v-model="timespan.days"
                      :value="30"
                      label="Days"
                      type="number"
                      min="0"
                      required
                      :rules="rules.number"
                      dense
                    />
                  </v-col>
                  <v-col class="pt-0">
                    <v-text-field
                      v-model="timespan.hours"
                      label="Hours"
                      type="number"
                      min="0"
                      max="23"
                      required
                      :rules="rules.number"
                      dense
                    />
                  </v-col>
                  <v-col class="pt-0">
                    <v-text-field
                      v-model="timespan.minutes"
                      label="Minutes"
                      type="number"
                      min="0"
                      max="59"
                      required
                      :rules="rules.number"
                      dense
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-form>
        </div>
      </v-col>
      <!-- PDF CONTENT -->
      <v-col
        cols="8"
        class="content"
      >
        <v-card
          :loading="isLoading"
          elevation="0"
        >
          <canvas
            class="sx-absolute-centered"
            :class="placing != null && 'placing'"
            :style="{ zIndex: 2 }"
            ref="overlay"
            @mousemove="mousemove"
            @mouseout="mouseout"
            @click="handleCanvasClick"
          />
          <canvas
            ref="canvas"
            class="sx-absolute-centered"
            :style="{ zIndex: 1 }"
          />
        </v-card>
      </v-col>
    </v-row>
    <prompt-dialog
      v-show="false"
      ref="promptDialog"
    />
    <v-dialog
      :value="choosingPlaceMode !== null"
      max-width="380"
      @click:outside="choosingPlaceMode = null"
    >
      <v-card>
        <v-card-title>Placement mode</v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-btn
                @click="
                  placing = choosingPlaceMode;
                  choosingPlaceMode = null;
                "
                color="primary"
                outlined
              >
                Fixed Position
              </v-btn>
            </v-col>
            <v-col>
              <v-btn
                @click="
                  placeReplaceText(choosingPlaceMode);
                  choosingPlaceMode = null;
                "
                color="primary"
                outlined
              >
                Replace Text
              </v-btn>
            </v-col>
          </v-row>
          <v-row v-if="placeModeElementTypeId === 5">
            <v-col class="text-center">
              <v-btn
                @click="
                  fixedPositionEveryPage(choosingPlaceMode)
                  choosingPlaceMode = null;
                "
                color="primary"
                outlined
              >
                Fixed Position Every Page
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      :value="clickElementOption !== null"
      max-width="380"
      @click:outside="clickElementOption = null"
    >
      <v-card>
        <v-card-title>
          Are you sure you want to delete this placemement?
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-btn
                @click="
                  deleteCanvasPlacement(clickElementOption);
                  clickElementOption = null;
                "
                color="primary"
                style="width: 130px;"
              >
                Yes
              </v-btn>
            </v-col>
            <v-col>
              <v-btn
                @click="clickElementOption = null"
                color="primary"
                style="width: 130px;"
                outlined
              >
                No
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      :value="localStorageRetrieve !== null"
      max-width="380"
      persistent
    >
      <v-card>
        <v-card-title>Retrieve unsaved data?</v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-btn
                @click="
                  agreeLocalStorage();
                  localStorageRetrieve = null;
                "
                color="primary"
                style="width: 130px;"
              >
                Yes
              </v-btn>
            </v-col>
            <v-col>
              <v-btn
                @click="
                  cancelLocalStorage();
                  localStorageRetrieve = null;
                "
                color="primary"
                style="width: 130px;"
                outlined
              >
                No
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      :value="clickRoleOption !== null"
      @click:outside="clickRoleOption = null"
      max-width="380"
    >
      <v-card>
        <v-card-title />
        <v-card-text>
          <v-row>
            <v-col>
              <v-btn
                @click="
                  deleteRole(clickRoleOption);
                  clickRoleOption = null;
                "
                color="primary"
                style="width: 130px;"
              >
                Delete
              </v-btn>
            </v-col>
            <v-col>
              <v-btn
                @click="
                  renameRole(clickRoleOption);
                  clickRoleOption = null;
                "
                color="primary"
                style="width: 130px;"
                outlined
              >
                Rename
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      :value="replacingTextWithElement != null"
      max-width="380"
      @click:outside="replacingTextWithElement = null"
    >
      <v-card :loading="replaceTextModalLoading">
        <v-card-title>Replace text element</v-card-title>
        <v-card-text v-if="replaceTextModalLoading">
          Loading PDF text elements
        </v-card-text>
        <v-card-text v-else>
          <v-autocomplete
            v-model="selectedPdfElement"
            :items="pdfTextElements"
            solo
          />
          <div class="text-right">
            <v-btn
              depressed
              color="success"
              @click="replaceTextWithElement"
            >
              Select Element
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import hover from '@/mixins/hover';
import pdf from '@/mixins/pdf';
import PdfNavigation from '@/components/SignPdf/PdfNavigation';
import FileDrop from '@/components/FileDrop';
import PdfAdminHeader from '@/components/SignPdf/Admin/PdfAdminHeader.vue';
import moment from 'moment';
import PromptDialog from '@/components/PromptDialog.vue';
import Bus from '@/bus';

export var myDocument = '';

export default {
  components: {
    PdfNavigation,
    FileDrop,
    PdfAdminHeader,
    PromptDialog,
  },
  mixins: [hover, pdf],
  data: () => ({
    isLoading: true,
    file: null,
    mouse: {
      x: -1,
      y: -1,
    },
    title: '',
    packageName: null,
    elementTypes: [],
    elements: [],
    activeDocument: {},
    documentList: [],
    clickElementOption: null,
    clickRoleOption: null,
    localStorageRetrieve: null,
    localStorageDocument: {},
    localStorageActiveDocument: {},
    resolve: null,
    reject: null,
    currentDocument: 0,
    userColors: [
      '#FEF8DD',
      '#ACDDDE',
      '#CAF1DE',
      '#FFCCCC',
      '#CE5C5E',
      '#709FC1',
      '#68B0AB',
      '#C8D5B9',
      '#E1F8DC',
      '#FFE7C7',
      '#F7D8BA',
    ],
    isMultipleDocuments: 0,
    elementsTable: {
      footerProps: {
        'items-per-page-options': [10, 20, 50, -1],
      },
    },
    environment: '',
    footerHeight: 10,
    tableHeight: 0,
    timespan: { minutes: 0, hours: 0, days: 0 },
    rules: {
      required: [(v) => !!v || 'Required.'],
      number: [(v) => new RegExp('^[0-9]*$').test(v) || 'Must be a number'],
    },
    template: {},
    serverPrefix: process.env.VUE_APP_SERVER_PREFIX,
    serverAddress: process.env.VUE_APP_SERVER_ADDRESS,
    promptBody: '',
    webhookId: null,
    transactionId: '',
    token: '',
    choosingPlaceMode: null,
    replaceTextModalLoading: false,
    pdfElements: [],
    selectedPdfElement: null,
    signeeOrderType: 1,
    isInitialsEveryPage: false,
    placeModeElementTypeId: 0
  }),
  beforeRouteEnter(to, from, next) {
    var environment;
    var transactionId;
    var token;
    var webhookId;
    if (to.query && to.query.trId && to.query.env && to.query.token) {
      transactionId = to.query.trId;
      environment = to.query.env;
      console.log(environment)
      token = to.query.token;
      next((vm) => {
        vm.init(transactionId, environment, token);
      });
    } else if (to.query && to.query.whId && to.query.env && to.query.token) {
      webhookId = to.query.whId;
      environment = to.query.env;
      token = to.query.token;
      next((vm) => {
        vm.initWebhook(webhookId, environment, token);
      });
    } else {
      alert('Error: Loading Documents');
    }
  },
  created() {
    this.isLoading = false;

  },
  computed: {
    lifespan() {
      if (this.timespan) {
        var lifespan = moment
          .duration(this.timespan.minutes, 'minutes')
          .add(this.timespan.hours, 'hours')
          .add(this.timespan.days, 'days')
          .asSeconds();
        return lifespan;
      }
      return false;
    },
    pdfTextElements() {
      if (this.pdfElements.length === 0) return;
      return this.pdfElements
        .reduce(this.parsePdfInfo, [])
        .filter(
          (element) =>
            element.text.replace(/\s+/, '').length !== 0 &&
            element.text.includes('SignPdf')
        );
    },

    itemsHeaders() {
      let headers = [];
      headers.push({ text: 'Name', value: 'name', width: '15%' });
      headers.push({ text: 'Type', value: 'type', width: '15%' });
      headers.push({ text: 'Font', value: 'fontId', width: '15%' });
      headers.push({ text: 'Font Size', value: 'fontSize', width: '20%' });
      headers.push({
        text: 'Actions',
        value: 'actions',
        sortable: false,
        width: 125,
        align: 'center fixed',
        class: 'fixed',
      });
      if (this.signeeOrderType == 2)
        headers.push({
          text: 'Sign Order',
          value: 'position',
          width: '12%',
          sortable: false,
          align: 'center fixed',
        });

      return headers;
    },
    checkWebhook() {
      if (this.webhookId !== null) return true;
      return false;
    },
  },
  watch: {},
  methods: {
    init(transactionId, environment, token) {
      this.environment = environment;
      console.log(environment)
      this.transactionId = transactionId;
      this.$api.setSxEnvironment(this.environment);
      this.token = token;
      Bus.$emit('loading');
      this.localStorageDocument = JSON.parse(localStorage.getItem('documents'));
      if (
        this.localStorageDocument &&
        this.localStorageDocument[0].transactionId == this.transactionId
      ) {
        this.localStorageActiveDocument = JSON.parse(
          localStorage.getItem('activeDocument')
        );

        if (this.localStorageActiveDocument) {
          const docIndex = this.localStorageDocument.findIndex(
            (doc) => doc.id == this.localStorageActiveDocument.id
          );
          this.localStorageDocument[docIndex] = this.localStorageActiveDocument;
        }

        this.localStorageRetrieve = this.openDialogLocalStorage();
      } else {
        this.localStorageDocument = null;
        this.getDocuments(this.transactionId);
      }

      this.getDropDownLists();
      Bus.$emit('loading');


    },
    getDropDownLists() {
      this.getElementTypes();
      this.getFonts();
    },
    openDialogLocalStorage() {
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    agreeLocalStorage() {
      this.getDocuments(this.transactionId);
      this.resolve(true);
    },
    cancelLocalStorage() {
      this.localStorageDocument = null;
      this.getDocuments(this.transactionId);
      this.resolve(false);
    },
    renderOverlay() {
      const canvas = this.$refs.overlay;
      const canvasContext = canvas.getContext('2d');

      canvasContext.clearRect(0, 0, canvas.width, canvas.height);

      if(this.zoom >= 1)
      {
        this.renderBox(this.placing, canvas, this.mouse.x, this.mouse.y);
      }
      else
      {
        this.renderBox(this.placing, canvas, this.mouse.x * this.zoom, this.mouse.y * this.zoom);
      }


    },
    mousemove(e) {
      this.mouse.x =
        Math.round((this.getX(e) / this.$refs.canvas.offsetWidth) * 1000) /
        1000;
      this.mouse.y =
        Math.round((this.getY(e) / this.$refs.canvas.offsetHeight) * 1000) /
        1000;

      const cursorPlacememnt = this.elements.find((element) => {
        const elementPlacement = element.placements.find((placement) => {
          return (
            this.mouse.y >= placement.yPosition  &&
            this.mouse.y <= placement.yPosition + element.fontSize / 1000 &&
            this.mouse.x >= placement.xPosition &&
            this.mouse.x <=
              placement.xPosition +
                this.getBoxWidth(
                  element.label,
                  element.fontSize,
                  this.$refs.overlay
                ) /
                  1000 &&
            placement.page == this.page
          );
        });
        if (elementPlacement) return true;
      });
      cursorPlacememnt
        ? (document.body.style.cursor = 'pointer')
        : (document.body.style.cursor = 'default');

      if (this.placing != null) this.renderOverlay();
    },
    mouseout() {
      this.mouse.x = -1;
      this.mouse.y = -1;
      document.body.style.cursor = 'default';
      this.renderOverlay();
    },
    setPdfZoom(incomingZoom)
    {
      this.setZoom(incomingZoom)
    },
    resetPdfZoom()
    {
      const defaultZoom = 1;
      this.setZoom(defaultZoom)
    },
    handleCanvasClick() {
      if (this.placing == null) {
        this.handleCanvasElementClick();
        return;
      }

      var updatedPlacements = this.elements[this.placing].placements;
      //If zoom out < 1 and element placed outside the canvas
      if(this.mouse.x < 0 || this.mouse.x > 1) return;

      //If Fixed Position Every Page
      if(this.isInitialsEveryPage && this.pagesCount > 1) {

        for(let p = 1; p < this.pagesCount + 1; p++)
        {
          updatedPlacements.push({
            page: p,
            xPosition: this.mouse.x,
            yPosition: this.mouse.y,
            documentId: this.currentDocument,
          });
        }
      }
      //Else Fixed position and Replace Text
      else
      {
        updatedPlacements.push({
          page: this.page,
          xPosition: this.mouse.x,
          yPosition: this.mouse.y,
          documentId: this.currentDocument,
        });
      }

      const updatedElement = {
        ...this.elements[this.placing],
        page: this.page,
        placements: updatedPlacements,
        text: null,
      };

      this.$set(this.elements, this.placing, updatedElement);
      this.placing = null;
      this.isInitialsEveryPage = false;
      this.saveLocalStorage();
      this.renderPdf();
    },
    handleCanvasElementClick() {
      const copiedElements = JSON.parse(JSON.stringify(this.elements));
      const foundElement = copiedElements.find((element) => {
        const elementPlacements = element.placements.find((placement) => {
          return (
            this.mouse.y >= placement.yPosition &&
            this.mouse.y <= placement.yPosition + element.fontSize / 1000 &&
            this.mouse.x >= placement.xPosition &&
            this.mouse.x <=
              placement.xPosition +
                this.getBoxWidth(
                  element.label,
                  element.fontSize,
                  this.$refs.overlay
                ) /
                  1000 &&
            placement.page == this.page
          );
        });

        if (elementPlacements) {
          element.placements = elementPlacements;
          return true;
        }
        return false;
      });

      if (foundElement) this.canvasElementClick(foundElement);
    },
    async handleSubmit() {
      if (await this.$refs.documentDataForm.validate()) {
        if (this.activeDocument.template.roles.length == 0) {
          Bus.$emit('alert', 'warning', 'Please identify the individuals who will be signing this document');
          return;
        }
        if (this.lifespan > 0) {
          if (this.webhookId !== null) {
            await this.submitWebhook();
          }
          await this.submitTemplate();
        } else {
          Bus.$emit('alert', 'error', 'Lifespan must be greater than 0');
        }
      }
    },
    async submitTemplate() {
      const currentDocIndex = this.documentList.findIndex(
        (doc) => doc.id == this.currentDocument
      );
      this.documentList[
        currentDocIndex
      ].template = this.activeDocument.template;

      try {
        var orderData = [];
        this.documentList.forEach((d) =>
          orderData.push({ documentId: d.id, order: d.order })
        );
        await this.$api.post(`sign-pdf/documents/change-order`, orderData);
        var data = {
          templates: [],
          roles: [],
          elements: [],
        };

        data.roles = JSON.parse(
          JSON.stringify(this.documentList[0].template.roles)
        );
        data.roles.map((role) => {
          role.elements = [];
        });

        data.elements = JSON.parse(JSON.stringify(this.elements));
        data.elements.forEach((element) => {
          element.placements = [];
        });

        this.documentList.forEach((doc) => {
          doc.template.roles.forEach((role) => {
            role.elements.forEach((element) => {
              data.elements.forEach((el) => {
                if (element.temporaryId == el.temporaryId) {
                  element.placements.forEach((place) => {
                    el.placements.push(JSON.parse(JSON.stringify(place)));
                  });
                }
              });
            });
          });
        });

        data.templates = this.documentList.map((doc) => {
          doc.template.roles = [];
          doc.template.lifespan = this.lifespan;
          return doc.template;
        });

        this.$api.setSxEnvironment(this.environment);
        await this.$api.setBearer(this.token);
        const res = await this.$api.post(`sign-pdf/templates`, data);
        this.isLoading = false;
        if (res.status === 200) {
          this.deleteLocalStorage();
          this.isError = false;
          this.redirectToSystemx();
        }
      } catch (error) {
        this.isLoading = false;

        let errorMessage = error;
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          if (error.response.data.message) {
            errorMessage = error.response.data.message;
          }
        }

        this.isError = true;
        this.message = errorMessage;
      }
    },
    async getTemplate(documentId) {
      if (documentId == null) return;

      var res = await this.$api.get(`sign-pdf/templates/${documentId}`);
      if (res.status == 200) {
        var data = res.data;
        data.roles.forEach((role) => {
          role.temporaryId = role.id;
          role.elements.map((element) => {
            element.color = role.color;
            element.temporaryId = element.id;
            element.roleId = role.order;
            element.elementType = this.elementTypes.find(
              (type) => type.id == element.elementTypeId
            ).name;

            element.placements.map((place) => {
              place.documentId = documentId;
            });
          });
        });
        return data;
      }
    },
    createNewUser() {
      var label = '';
      var checkUnique = null;

      do {
        if (checkUnique != null)
          alert('Sorry, but this name is already taken.');
        label = prompt(`Please identify the individual who will be signing this document`, label);
        if (!label) return;

        checkUnique = this.documentList.find((doc) => {
          return doc.template.roles.find((role) => role.name === label);
        });
      } while (checkUnique);

      var missingOrderNum = 0;
      var roleOrderNumbers = this.activeDocument.template.roles.map(
        (r) => r.order
      );
      for (var i = 1; i < this.activeDocument.template.roles.length + 1; i++) {
        if (roleOrderNumbers.indexOf(i) == -1) missingOrderNum = i;
      }
      if (missingOrderNum == 0)
        missingOrderNum = this.activeDocument.template.roles.length + 1;

      var roleColors = JSON.parse(JSON.stringify(this.userColors));
      this.activeDocument.template.roles.forEach((r) => {
        var index = roleColors.indexOf(r.color);
        if (index !== -1) roleColors.splice(index, 1);
      });
      var availableRoleColor = roleColors[0];

      let newRole = {
        name: label,
        order: missingOrderNum,
        color: '',
        elements: [],
        temporaryId: Date.now(),
      };

      this.documentList.forEach((doc) => {
        newRole.color = availableRoleColor;
        doc.template.roles.push(JSON.parse(JSON.stringify(newRole)));
      });
      this.activeDocument.template.roles.push(
        JSON.parse(JSON.stringify(newRole))
      );
      this.saveLocalStorage();
    },
    changeFonts() {
      this.elements = [];
      this.activeDocument.template.roles.forEach((role) =>
        this.elements.push(...role.elements)
      );
      this.renderPdf();
    },
    changeOrder(role, direction) {
      if (role == null && direction == null) return;

      const currentRoleOrder = JSON.parse(
        JSON.stringify(
          this.activeDocument.template.roles.find((r) => r.order == role.order)
            .order
        )
      );
      const currentRoleIndex = this.activeDocument.template.roles.findIndex(
        (r) => r.temporaryId == role.temporaryId
      );

      if (direction == 1) {
        if (currentRoleOrder != 1) {
          const nextRoleIndex = this.activeDocument.template.roles.findIndex(
            (r) => r.order == role.order - 1
          );
          this.changeRoleOrderElements(
            currentRoleIndex,
            this.activeDocument.template.roles[nextRoleIndex].order
          );
          this.activeDocument.template.roles[
            currentRoleIndex
          ].order = this.activeDocument.template.roles[nextRoleIndex].order;

          this.changeRoleOrderElements(nextRoleIndex, currentRoleOrder);
          this.activeDocument.template.roles[
            nextRoleIndex
          ].order = currentRoleOrder;

          this.changeOrderDocumentList(
            currentRoleOrder,
            currentRoleOrder - 1,
            this.activeDocument.template.roles[currentRoleIndex].temporaryId,
            this.activeDocument.template.roles[nextRoleIndex].temporaryId
          );
        }
      } else {
        if (currentRoleOrder < this.activeDocument.template.roles.length) {
          const nextRoleIndex = this.activeDocument.template.roles.findIndex(
            (r) => r.order == role.order + 1
          );
          this.changeRoleOrderElements(
            currentRoleIndex,
            this.activeDocument.template.roles[nextRoleIndex].order
          );
          this.activeDocument.template.roles[
            currentRoleIndex
          ].order = this.activeDocument.template.roles[nextRoleIndex].order;

          this.changeRoleOrderElements(nextRoleIndex, currentRoleOrder);
          this.activeDocument.template.roles[
            nextRoleIndex
          ].order = currentRoleOrder;
          this.changeOrderDocumentList(
            currentRoleOrder,
            currentRoleOrder + 1,
            this.activeDocument.template.roles[currentRoleIndex].temporaryId,
            this.activeDocument.template.roles[nextRoleIndex].temporaryId
          );
        }
      }
      this.elements = [];
      this.activeDocument.template.roles.forEach((role) =>
        this.elements.push(...role.elements)
      );
      this.saveLocalStorage();
    },
    changeOrderDocumentList(
      currentRoleOrder,
      nextRoleOrder,
      currentRole,
      nextRole
    ) {
      this.documentList.forEach((doc) => {
        doc.template.roles.forEach((role) => {
          if (role.temporaryId == currentRole) {
            role.order = nextRoleOrder;
            role.elements.map((elem) => {
              elem.roleId = nextRoleOrder;
            });
          }

          if (role.temporaryId == nextRole) {
            role.order = currentRoleOrder;
            role.elements.map((elem) => {
              elem.roleId = currentRoleOrder;
            });
          }
        });
      });
    },
    changeRoleOrderElements(currentRoleIndex, newOrder) {
      this.activeDocument.template.roles[currentRoleIndex].elements.forEach(
        (elem) => {
          elem.roleId = newOrder;
        }
      );
    },
    changeDocumentOrder(document, direction) {
      if (document == null && direction == null) return;

      const currentDocumentOrder = document.order;
      const currentDocumentIndex = this.documentList.findIndex(
        (doc) => doc.id == document.id
      );
      var nextDocumentIndex = -1;

      if (direction == 1) {
        nextDocumentIndex = this.documentList.findIndex((doc) => {
          if (doc.order == currentDocumentOrder - 1) return true;
        });
      } else {
        nextDocumentIndex = this.documentList.findIndex((doc) => {
          if (doc.order == currentDocumentOrder + 1) return true;
        });
      }

      if (nextDocumentIndex != -1) {
        this.documentList[currentDocumentIndex].order = this.documentList[
          nextDocumentIndex
        ].order;
        this.documentList[nextDocumentIndex].order = currentDocumentOrder;
      }
    },
    async changeCurrentDocument(document) {
      const currentDocIndex = this.documentList.findIndex(
        (doc) => doc.id == this.currentDocument
      );
      this.documentList[currentDocIndex].template = JSON.parse(
        JSON.stringify(this.activeDocument.template)
      );
      this.documentList.forEach((d) => {
        d.template.roles.forEach((r) => {
          r.elements.forEach((e) => {
            this.elements.forEach((e2) => {
              if (e.temporaryId === e2.temporaryId) {
                e.fontSize = e2.fontSize;
                e.fontId = e2.fontId;
              }
            });
          });
        });
      });
      this.page = 1;
      this.activeDocument = null;
      this.elements = [];

      this.currentDocument = document.id;
      this.file = document.file;

      this.activeDocument = JSON.parse(JSON.stringify(document));

      this.activeDocument.template.roles.forEach((role) =>
        this.elements.push(...role.elements)
      );
    },
    changeTitle(newTitle) {
      this.title = newTitle;
    },
    renameRole(roleOrder) {
      var label = '';
      var checkUnique = null;

      do {
        if (checkUnique != null)
          alert('Sorry, but this name is already taken.');
        label = prompt(`What is the role of the user?`, label);
        if (!label) return;

        checkUnique = this.documentList.find((doc) => {
          return doc.template.roles.find((role) => role.name === label);
        });
      } while (checkUnique);
      this.activeDocument.template.roles.forEach((r) => {
        if (r.order == roleOrder) {
          r.name = label;
        }
      });
      this.documentList.forEach((d) => {
        d.template.roles.forEach((r) => {
          if (r.order == roleOrder) {
            r.name = label;
          }
        });
      });
    },

    async getElementTypes() {
      try {
        this.$api.setSxEnvironment(this.environment);
        await this.$api.setBearer(this.token);
        const res = await this.$api.get(`sign-pdf/templates/elements/types`);
        this.isLoading = false;
        if (res.status === 200) {
          this.elementTypes = res.data;

          this.isError = false;
        }
      } catch (error) {
        this.isLoading = false;

        let errorMessage = error;
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          if (error.response.data.message) {
            errorMessage = error.response.data.message;
          }
        }

        this.isError = true;
        this.message = errorMessage;
      }
    },
    async getFonts() {
      try {
        this.$api.setSxEnvironment(this.environment);
        await this.$api.setBearer(this.token);

        const res = await this.$api.get(`fonts`);
        this.isLoading = false;
        if (res.status === 200) {
          this.fonts = res.data;
          this.isError = false;
        }
      } catch (error) {
        this.isLoading = false;

        let errorMessage = error;
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          if (error.response.data.message) {
            errorMessage = error.response.data.message;
          }
        }

        this.isError = true;
        this.message = errorMessage;
      }
    },
    async getDocuments(transactionId) {
      if (transactionId == null) return;
      try {
        this.$api.setSxEnvironment(this.environment);
        const response = await this.$api.get(
          `sign-pdf/documents/${transactionId}`
        );
        const getFiles = await this.$api.get(
          `sign-pdf/transactions/download-documents/${transactionId}`
        );
        for (let i = 0; i < response.data.length; i++) {
          let document = response.data[i];

          if (this.localStorageDocument != null)
            document = this.localStorageDocument[i];
          else {
            const templateExists = await this.$api.get(
              `sign-pdf/templates/templateExists/${document.id}`
            );
            templateExists.data == true
              ? (document.template = await this.getTemplate(document.id))
              : (document.template = {
                  roles: [],
                  name: document.originalName,
                  documentId: document.id,
                });
          }
          if(getFiles && getFiles.data && getFiles.data.length > 0)
          {
            const file = getFiles.data.find((f) => f.documentId === document.id);
            const byteCharacters = atob(file.fileContent.fileContents);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            document.file = new File(
              [byteArray],
              file.fileContent.fileDownloadName
            );
          }

          this.documentList.push(document);
        }
        this.currentDocument = this.documentList[0].id;
        this.activeDocument = JSON.parse(JSON.stringify(this.documentList[0]));
        this.activeDocument.template.roles.forEach((role) =>
          this.elements.push(...role.elements)
        );
        if(!this.webhookId) this.file = this.documentList[0].file;
        const transaction = await this.$api.get(
          `sign-pdf/transactions/${transactionId}`
        );

        this.setLifeSpan(this.documentList[0].template.lifespan);
        this.isMultipleDocuments = transaction.data.isMultipleDocuments;
        this.signeeOrderType = transaction.data.signeeOrderType;
        this.title = transaction.data.name;
        this.isLoading = false;
        this.onResize()
      } catch (error) {
        this.file = '';
        this.isLoading = false;
        let errorMessage = error;
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          if (error.response.data.message) {
            errorMessage = error.response.data.message;
          }
        }
        this.isError = true;
        this.message = errorMessage;
      }
    },
    setLifeSpan(lifespan = null) {
      if (lifespan == null) {
        this.timespan.days = 30;
        return;
      }

      const lifespanDuration = moment.duration(lifespan, 'seconds')._data;

      if (lifespanDuration.months > 0)
        this.timespan.days =
          lifespanDuration.days + lifespanDuration.months * 30;
      else if (lifespanDuration.years > 0)
        this.timespan.days =
          lifespanDuration.days +
          lifespanDuration.months * 30 +
          lifespanDuration.years * 365;
      else this.timespan.days = lifespanDuration.days;

      this.timespan.hours = lifespanDuration.hours;
      this.timespan.minutes = lifespanDuration.minutes;
    },
    saveLocalStorage() {
      localStorage.setItem('documents', JSON.stringify(this.documentList));
      localStorage.setItem(
        'activeDocument',
        JSON.stringify(this.activeDocument)
      );
    },
    deleteLocalStorage() {
      localStorage.removeItem('documents');
      localStorage.removeItem('activeDocument');
    },
    async handleIsLastPageChange(temporaryId) {
      var elementIndex = this.elements.findIndex(
        (x) => x.temporaryId == temporaryId
      );
      var updatedElement;
      const confirm = await this.$refs.promptDialog.open({
        message: 'You will need to re-place the element',
      });
      if (confirm) {
        updatedElement = {
          ...this.elements[elementIndex],
          xPosition: 0,
          yPosition: 0,
          page: 0,
        };
        this.$set(this.elements, elementIndex, updatedElement);
        this.renderPdf();
      } else {
        updatedElement = {
          ...this.elements[elementIndex],
          isLastPage: !this.elements[elementIndex].isLastPage,
        };
        this.$set(this.elements, elementIndex, updatedElement);
      }
    },
    getPdfData() {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = (e) => {
          resolve(e.target.result);
        };
        reader.onerror = (e) => {
          reject(e.target.error);
        };
        reader.readAsArrayBuffer(this.file);
      });
    },
    newElement(elementTypeId, elementType, currentRole) {
      if (elementTypeId == null && elementType == null && currentRole == null)
        return;
      let label = '';
      let checkUnique = null;

      do {
        if (checkUnique != null)
          alert('Sorry, but this name is already taken.');

          label = prompt(
          `What is the name of the ${elementType.toLowerCase()} element?`,
            elementType
          );
          if (!label) return;

        checkUnique = this.documentList.find((doc) =>
          doc.template.roles.find((role) =>
          role.order === currentRole.order &&
          role.elements.find(elem => elem.label === label)))
      } while (checkUnique);

      const newElement = {
        elementType,
        elementTypeId,
        label,
        fontSize: elementTypeId === 1 ? 30 : 20,
        fontId: 1,
        page: 0,
        xPosition: 0,
        yPosition: 0,
        temporaryId: Date.now(),
        roleId: currentRole.order,
        color: currentRole.color,
        placements: [],
      };
      this.elements.push(newElement);
      this.documentList.forEach((doc) => {
        const roleIndex = doc.template.roles.findIndex(
          (role) => role.temporaryId == currentRole.temporaryId
        );
        doc.template.roles[roleIndex].elements.push(
          JSON.parse(JSON.stringify(newElement))
        );
      });

      const roleIndex = this.activeDocument.template.roles.findIndex(
        (role) => role.temporaryId == currentRole.temporaryId
      );
      this.activeDocument.template.roles[roleIndex].elements.push(newElement);
      this.saveLocalStorage();
    },
    returnItemColor(user) {
      if (user.order) return user.color;
    },
    place(temporaryId, elementTypeId) {
      this.placeModeElementTypeId = elementTypeId;
      this.choosingPlaceMode = this.elements.findIndex(
        (x) => x.temporaryId === temporaryId
      );
    },
    canvasElementClick(foundElement) {
      this.clickElementOption = foundElement;
    },
    deleteCanvasPlacement(foundElement) {
      const elementIndex = this.elements.findIndex(
        (element) => element.temporaryId === foundElement.temporaryId
      );
      const placementIndex = this.elements[elementIndex].placements.findIndex(
        (placement) =>
          placement.xPosition == foundElement.placements.xPosition &&
          placement.yPosition == foundElement.placements.yPosition &&
          placement.page == foundElement.placements.page
      );
      this.elements[elementIndex].placements.splice(placementIndex, 1);
      this.renderPdf();
      this.saveLocalStorage();
    },
    async placeReplaceText(element) {
      this.replacingTextWithElement = element;

      if (this.pdfElements.length === 0) {
        this.replaceTextModalLoading = true;
        await this.fetchPdfElements();
        this.replaceTextModalLoading = false;
      }
    },
    fixedPositionEveryPage(placing)
    {
      this.placing = placing
      this.isInitialsEveryPage = true;
    },
    async fetchPdfElements() {
      let formData = new FormData();
      formData.append('content', this.file);

      try {
        this.$api.setSxEnvironment(this.environment);
        await this.$api.setBearer(this.token);
        const res = await this.$api.post(
          'sign-pdf/templates/pdf_json',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        );
        this.pdfElements = JSON.parse(res.data);
      } catch (error) {
        this.isLoading = false;

        let errorMessage = error;
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          if (error.response.data.message) {
            errorMessage = error.response.data.message;
          }
        }

        this.isError = true;
        this.message = errorMessage;
      }
    },
    replaceTextWithElement() {
      this.elements[this.replacingTextWithElement].placements.push({
        replaceText: this.selectedPdfElement.data,
        page: this.selectedPdfElement.page,
        xPosition: this.selectedPdfElement.left,
        yPosition: this.selectedPdfElement.top,
        documentId: this.currentDocument,
      });
      this.replacingTextWithElement = null;
    },
    deleteElement(temporaryId) {
      if (temporaryId == null) return;

      if (confirm('Are you sure you would like to delete this element?')) {
        this.documentList.forEach((doc) => {
          doc.template.roles.forEach((role) => {
            var eIndex = role.elements.findIndex(
              (role) => role.temporaryId == temporaryId
            );
            if (eIndex != -1) role.elements.splice(eIndex, 1);
          });
        });

        this.activeDocument.template.roles.forEach((role) => {
          var eIndex = role.elements.findIndex(
            (role) => role.temporaryId == temporaryId
          );
          if (eIndex != -1) {
            role.elements.splice(eIndex, 1);
            return;
          }
        });

        const indexElement = this.elements.findIndex(
          (elem) => elem.temporaryId == temporaryId
        );
        this.elements.splice(indexElement, 1);
        this.renderPdf();
      }
    },
    deleteRole(order) {
      if (order == null) return;

      if (confirm('Are you sure you would like to delete this role?')) {
        this.documentList.forEach((doc) => {
          let roleInd = doc.template.roles.findIndex(
            (role) => role.order == order
          );
          if (roleInd != -1) doc.template.roles.splice(roleInd, 1);
        });

        var roleInd = this.activeDocument.template.roles.findIndex(
          (role) => role.order == order
        );
        if (roleInd != -1)
          this.activeDocument.template.roles.splice(roleInd, 1);

        var elementIndexs = [];
        for (let i = 0; i < this.elements.length; i++) {
          if (this.elements[i].roleId == order) elementIndexs.push(i);
        }
        elementIndexs.forEach((idx) => this.elements.splice(idx, 1));

        let roleOrder = order;
        this.documentList.forEach((d) => {
          // eslint-disable-next-line no-unused-vars
          d = this.changeRoleOrderAfterDelete(d, roleOrder);
        });

        this.activeDocument = this.changeRoleOrderAfterDelete(
          this.activeDocument,
          roleOrder
        );

        this.renderPdf();
        this.saveLocalStorage();
      }
    },
    changeRoleOrderAfterDelete(document, roleOrder) {
      let d = document;
      d.template.roles.forEach(() => {
        let roleIndex = d.template.roles.findIndex(
          (r) => r.order == roleOrder + 1
        );

        if (roleIndex == -1) return;

        let newOrder = d.template.roles[roleIndex].order;
        d.template.roles[roleIndex].elements.forEach((e) => {
          e.roleId = roleOrder;
        });
        d.template.roles[roleIndex].order = roleOrder;
        roleOrder = newOrder;
      });

      return d;
    },
    pdfUploaded() {
      this.file = this.$refs.pdfInput.files[0];
    },
    onResize() {
      const headerHeight = 50
      this.tableHeight =
        window.innerHeight -
        this.$refs.resizableDiv.getBoundingClientRect().y -
        this.$refs.resizableDivDocuments.getBoundingClientRect().y -
        this.$refs.resizableDivLifespan.getBoundingClientRect().height + headerHeight

    },
    redirectToSystemx() {
      this.webhookId == null
        ? window.location.replace(
            `${this.serverPrefix}${this.environment}.${this.serverAddress}/sign`
          )
        : window.location.replace(
            `${this.serverPrefix}${this.environment}.${this.serverAddress}/admins?page=webhook`
          );
    },

    //WEBHOOK SECTION###############################################################################
    initWebhook(webhookId, environment, token) {
      this.environment = environment;
      this.webhookId = webhookId;
      this.token = token;
      this.getDropDownLists();
      this.getDocumentWebhook();
      this.$api.setSxEnvironment(this.environment);
    },

    async getDocumentWebhook() {

      var response = await this.$api.get(
        `report-webhooks/get-transaction/${this.webhookId}`
      );

      const submitItem = {filter: {id : this.webhookId}}
      var responseWebhook = await this.$api.post(
        `report-webhooks/read`,
        submitItem
      );

      this.webhook = responseWebhook.data[0];

      var transactionId = response.data;
      if (transactionId !== 0) {
        this.localStorageDocument = null;
        this.getDocuments(transactionId);
      } else {
        this.createNewDocumentWebhook();
      }

      const resFile = await this.$api.get(
        `report-webhooks/get-template-file/${this.webhook.moduleId}/${this.environment}`
      );
      const byteCharacters = atob(resFile.data.file);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      this.file = new File(
        [byteArray],
       'webhook_template.pdf',
        { type: 'application/pdf' }
      );
      this.fetchPdfElements();
    },

    createNewDocumentWebhook() {
      this.documentList[0] = {};
      this.documentList[0].template = {
        roles: [
          {
            name: 'Signee',
            order: 1,
            color: this.userColors[0],
            elements: [],
            temporaryId: Date.now(),
          },
        ],
        name: 'File name',
      };
      this.activeDocument = JSON.parse(JSON.stringify(this.documentList[0]));
      this.currentDocument = this.documentList[0].id;
      this.setLifeSpan();
    },

    reuploadFileWebhook() {
      this.file = null;
      this.createNewDocumentWebhook();
    },

    async submitWebhook() {
      try {
        var fileName = this.file.name.substring(0, this.file.name.length - 4);
        var transactionData = {
          name: fileName,
          createdBy: 0,
          signeeOrderType: 1,
          isMultipleDocuments: 0,
          isWebhook: 1,
        };

        const responseTransaction = await this.$api.post(
          `sign-pdf/transactions/create`,
          transactionData
        );

        if (responseTransaction.status !== 200) return;

        var transactionId = responseTransaction.data.id;
        let formData = new FormData();
        formData.append('Name', fileName);
        formData.append('TransactionId', transactionId);
        formData.append('File', this.file);

        const responseDocument = await this.$api.post(
          `sign-pdf/documents/create`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        );

        if (responseDocument.status !== 200) return;

        var documentId = responseDocument.data.id;
        var orderData = [];
        orderData.push({ documentId: documentId, order: 0 });
        await this.$api.post(`sign-pdf/documents/change-order`, orderData);

        this.activeDocument.id = documentId;
        this.documentList[0].id = documentId;
        this.activeDocument.template.documentId = documentId;
        this.activeDocument.template.webhookId = this.webhookId;
        this.currentDocument = documentId;

        this.activeDocument.template.roles.forEach((r) => {
          r.elements.forEach((e) => {
            e.placements.forEach((p) => {
              p.documentId = documentId;
            });
          });
        });
      } catch (error) {
        this.isLoading = false;

        let errorMessage = error;
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          if (error.response.data.message) {
            errorMessage = error.response.data.message;
          }
        }

        this.isError = true;
        this.message = errorMessage;
      }
    },
  },
};
</script>

<style lang="scss">
.container {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
}
.content {
  flex-grow: 1;
  height: 99.3% !important;
  border: 1px solid rgba(0,0,0,0.2);
  overflow-x: scroll;
  background-color: lightgrey;
}
.elementsTable th {
  font-size: 11.9px !important;
}

.elementsTable td {
  font-size: 11.9px !important;
}
html {
  margin: 0;
  padding: 0;
  overflow: hidden;
}
.placing {
  cursor: crosshair;
}
.action-bar {
  background-color: #f0f0f0 !important;
  max-height: 52px !important;
}
.no-uppercase {
     text-transform: unset !important;
}
.not-active {
  pointer-events: none;
  cursor: default;
  text-decoration: none;
  color: grey !important;
}
.cell-overflow {
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
table > thead > tr > th.fixed:nth-last-child(2) {
  position: sticky !important;
  position: -webkit-sticky !important;
  right: 0;
  width: 150vw;
  background: white;
  -webkit-box-shadow: -1px 0px 3px -1px rgba(0, 0, 0, 0.19);
  -moz-box-shadow: -1px 0px 3px -1px rgba(0, 0, 0, 0.19);
  box-shadow: -1px 0px 3px -1px rgba(0, 0, 0, 0.19);
}
table > thead > tr > td {
  font-size: 1.2em;
}

#cellOverflow {
  position: sticky !important;
  position: -webkit-sticky !important;
  right: 0;
  width: 150vw;
}
#signeeName {
  min-width: 200px;
}
.documentItem:hover {
  background: #dff0d8 !important;
}
.rowElement:hover {
  background: white !important;
}

/*table > thead > tr > th.fixed:nth-last-child(1) {
  z-index: 101;
}*/
#templateId {
  background-color: red;
}
</style>
